export var AbTests;
(function (AbTests) {
    AbTests["ChildAccounts"] = "common_familyAccount_200529";
    AbTests["LessonsAndComics"] = "junior_lessons_200507";
    AbTests["SeasonEvents"] = "junior_seasonalDesign_201015";
    AbTests["Storyline"] = "junior_storyline_201123";
    AbTests["AlbertABC"] = "junior_abc_210118";
    AbTests["Developer"] = "junior_developer_210525";
    AbTests["Preboarding"] = "junior_preboarding_210907";
    AbTests["JuniorAbcOneApp"] = "junior_abc_oneapp_210809";
    AbTests["JuniorCodeApp"] = "junior_code_app_220520";
    AbTests["JuniorJarambaApp"] = "junior_jaramba_app_220520";
    AbTests["JuniorDailyRewards"] = "junior_daily_rewards_220919";
    AbTests["JuniorPet"] = "junior_pet_230323";
    AbTests["JuniorMathInstructionRepeat"] = "junior_math_instruction_repeat_231129";
    AbTests["JuniorCodeBikkolandMap"] = "junior_code_bikkoland_map_20240318";
    AbTests["JuniorImprovedPaywall"] = "junior_improved_paywall_20240422";
    AbTests["JuniorHorizontalPaywall"] = "junior_horizontal_paywall_20240422";
    AbTests["JuniorMathExerciseIteration"] = "junior_math_exercise_iteration_20240509";
    AbTests["JuniorPaywallMonthlyYearly"] = "junior_paywall_monthly_yearly_20240515";
    AbTests["JuniorPaywallIcon"] = "junior_paywall_icon_20240715";
    AbTests["JuniorGlowingEffect"] = "junior_glowing_effect_20240930";
    AbTests["JuniorShortenMap"] = "junior_shorten_map_20241007";
    AbTests["JuniorDailyChallenge"] = "junior_daily_challenge_20241014";
    AbTests["JuniorVideoPaywall"] = "junior_video_paywall_20241207";
})(AbTests || (AbTests = {}));
//# sourceMappingURL=AbTests.js.map